<template>
  <span class="screening-flag-icon">
    <b-tooltip
      label="Flagged for exclusion"
      v-if="exclusion"
    >
      &#128681;
    </b-tooltip>
    <b-tooltip
      label="Flagged for inclusion"
      v-if="inclusion"
    >
      &#9989;
    </b-tooltip>
  </span>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    exclusion: {
      type: Boolean,
      default: false,
    },
    inclusion: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style lang="scss">
  .screening-flag-icon {
    cursor: help;
  }
</style>